document.addEventListener('submit', async function (e) {
  var f = e.target;
  if (!f.classList || !f.classList.contains('js-add-form')) return;
  var s = e.submitter;
  if (s && s.name === 'return_to') return;
  e.preventDefault();
  var btn = s || f.querySelector('button');
  var label = btn.textContent;
  btn.disabled = true;
  try {
    var r = await fetch(window.theme.cartAdd, { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } });
    if (!r.ok) throw new Error('add failed');
    var cart = await (await fetch(window.theme.cart, { headers: { Accept: 'application/json' } })).json();
    document.querySelectorAll('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
    btn.textContent = 'Added';
  } catch (err) {
    btn.textContent = 'Try again';
  }
  setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1500);
});
